module.exports = __webpack_public_path__ + "img/tso_op.8d1a4474.png";